// extracted by mini-css-extract-plugin
export default {"guide":"Guide_guide__TOOCL","section":"Guide_section__75c-d","list":"Guide_list__8HCPS"};